import BulkUpload from '@/components/BulkUpload';

export default function BatchImport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground">Batch Import</h2>
        <p className="text-muted-foreground">Import multiple products via CSV file</p>
      </div>
      <BulkUpload />
    </div>
  );
}
